import { createFileRoute } from '@tanstack/react-router';

import { NotificationsView } from 'src/sections/notifications/notifications-view';

// The inbox has no tenant in its path on purpose: it is scoped to the signed-in
// user, and its rows can span every brand that user can reach.
export const Route = createFileRoute('/_authed/dashboard/notifications')({
  component: NotificationsView,
});
